/* MG PDP Init — hooks Spotlight PDP into mg-conversion features + adds urgency signals */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Wire up data attributes for mg-conversion.js ── */
  var productInfo = document.querySelector('product-info[data-product-id]');
  if (productInfo) {
    var productId = productInfo.getAttribute('data-product-id');
    productInfo.setAttribute('data-mg-product-id', productId);

    var infoCol = productInfo.querySelector('.product__info-container');
    if (infoCol) {
      infoCol.setAttribute('data-mg-pdp-info', '');

      /* Inject Google Pay payment line above buy buttons */
      var buyButtons = infoCol.querySelector('.product-form__buttons, [data-type="buy_buttons"]');
      if (buyButtons && !document.getElementById('mg-payment-line')) {
        var payLine = document.createElement('div');
        payLine.id = 'mg-payment-line';
        payLine.style.cssText = 'font-size:13px;display:flex;align-items:center;gap:6px;color:#555;margin-bottom:12px;';
        buyButtons.parentNode.insertBefore(payLine, buyButtons);
      }

      /* Price anchor for low-stock indicator */
      var priceBlock = infoCol.querySelector('[id^="price-"]');
      if (priceBlock) priceBlock.setAttribute('data-mg-price-anchor', '');

      /* ── Urgency: Delivery estimate nudge ──
         Shows below buy buttons: “Order before 2pm for dispatch today”
         Only on weekdays AEST (UTC+10/11). */
      if (buyButtons) {
        var now = new Date();
        var aestOffset = 10; /* use AEST; close enough for this nudge */
        var aestHour = (now.getUTCHours() + aestOffset) % 24;
        var aestDay = new Date(now.getTime() + aestOffset * 3600000).getUTCDay(); /* 0=Sun,6=Sat */
        var isWeekday = aestDay >= 1 && aestDay <= 5;
        var nudgeEl = document.createElement('div');
        nudgeEl.className = 'mg-pdp-delivery-nudge';
        if (isWeekday && aestHour < 14) {
          nudgeEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>Order before 2pm AEST for <strong>same-day dispatch</strong>';
        } else if (isWeekday) {
          nudgeEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v4h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Free shipping Australia-wide — <strong>dispatches next business day</strong>';
        } else {
          nudgeEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v4h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Free shipping Australia-wide — <strong>dispatches Monday</strong>';
        }
        var afterBuy = buyButtons.parentNode;
        afterBuy.insertBefore(nudgeEl, buyButtons.nextSibling);
      }
    }
  }

  /* ── Collection cards: wire up quick-add attributes ── */
  document.querySelectorAll('.card-wrapper').forEach(function (wrapper) {
    var link = wrapper.querySelector('a.full-unstyled-link, a[href*="/products/"]');
    var info = wrapper.querySelector('.card__information, .card__content');
    if (!link || !info) return;
    link.setAttribute('data-mg-pcard', '');
    if (!info.hasAttribute('data-mg-pcard-body')) {
      info.setAttribute('data-mg-pcard-body', '');
    }
  });

  /* ── Mobile sticky ATC bar ──
     On mobile, adds a fixed bar at the bottom with product name + ATC button.
     Only shows when the main ATC button is scrolled out of view. */
  var atcForm = document.querySelector('product-form form, form[action*="/cart/add"]');
  var atcBtn = atcForm && atcForm.querySelector('[name="add"], .product-form__submit');
  var productTitle = document.querySelector('.product__title h1, .product__title h2');

  if (atcBtn && productTitle) {
    var stickyBar = document.createElement('div');
    stickyBar.className = 'mg-sticky-atc';
    stickyBar.id = 'mg-sticky-atc';
    stickyBar.innerHTML =
      '<span class="mg-sticky-atc__name">' + productTitle.textContent.trim() + '</span>' +
      '<button type="button" class="mg-sticky-atc__btn" id="mg-sticky-atc-btn">Add to Cart</button>';
    document.body.appendChild(stickyBar);

    var stickyBtn = document.getElementById('mg-sticky-atc-btn');

    /* Show/hide based on ATC button visibility */
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('mg-sticky-atc--visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(atcBtn);

    /* Proxy click to the real ATC button */
    stickyBtn.addEventListener('click', function () {
      atcBtn.click();
    });
  }

  /* ── Cart drawer upsell ── */
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    drawer.addEventListener('on:cart-drawer:open', function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart.item_count) return;
        var pid = cart.items[0].product_id;
        var ids = cart.items.map(function (i) { return i.product_id; });
        if (window.mgLoadDrawerUpsell) window.mgLoadDrawerUpsell(pid, ids);
      });
    });
  }

});
